import ObjectStatisticIcon from './component'

export default ObjectStatisticIcon
